import { Box, IconButton, Typography } from "@mui/material";

export const LabelWithIcons = ({ label, actions }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Typography>{label}</Typography>
    {actions.map((action, index) => (
      <IconButton
        key={index}
        size="small"
        onClick={e => {
          e.preventDefault();
          action.onClick();
        }}
        disabled={action.disabled}
        sx={{ padding: "2px" }}
      >
        {action.icon}
      </IconButton>
    ))}
  </Box>
);
